<template>
	<div>
		<b-navbar id="main_nav" class="container" type='dark' fixed='top'>
			<b-navbar-nav>
				<b-nav-item class='d-none d-md-block' v-for="item in items" :key="item.name" :active='item.active' :href="item.name" v-on:click="selectedLink(item.name)">
					<span>{{item.title}}</span>
				</b-nav-item>
				<b-nav-item class='d-md-none d-block' href="#home" v-on:click="selectedLink('open')">
<i class="material-icons">
menu
</i>
				</b-nav-item>
			</b-navbar-nav>
		</b-navbar>
	</div>
</template>
<script>
export default {
	name: 'MainNavTop',
	props: {
		// nav items as objects
		items: Object
	},
	methods:{
		selectedLink(name){
			this.$emit('nav',name)
		}
	}
}
</script>